var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"date",staticClass:"form-control new-design date-icon",attrs:{"inputmode":"none","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }